interface ClientNameDisplay {
    ID?: number;
    clientName?: string;
    clientPhone?: string;
}

interface ClientNameItemProps {
    client: ClientNameDisplay;
    onClick?: (clientId: number) => void;
}

const ClientNameItem = ({ client, onClick }: ClientNameItemProps) => {
    return (
        <>
            <h6
                className="mb-1 text-break cursor-pointer"
                onClick={() => (onClick && client.ID ? onClick(client.ID) : undefined)}
            >
                {client.clientName || '-'}
            </h6>
            <p className="text-muted f-12 mb-0 my-1">{client.clientPhone || '-'}</p>
        </>
    );
};

export default ClientNameItem;
